module.exports = __webpack_public_path__ + "static/media/event7.331fad92.jpg";